import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import BaseAbility from '@/ability/views/BaseAbility.vue';
import DownloadView from '@/ability/views/DownloadView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/mobile_avocado_ck',
    name: 'home',
    meta: {
      title: 'WPS Office',
      noCache: false,
    },
    component: BaseAbility,
  },
  {
    path: '/mobile_avocado_ck/download',
    name: 'download',
    component: DownloadView,
    meta: {
      noCache: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
